import service from '@/utils/server';
let modelPath = 'tms/index';

export const getIndexCount = data => {
    return service({
      url: modelPath + '/getIndexCount?shipperCode=' + data,
        method: 'post',
    })
};



// WEBPACK FOOTER //
// ./src/page/myTasks/myTasks/api/index.js